export const supports = {
  context: false,
  accessToken: false,
  enabled: false
};

/* UPM REST API content-types */
export const REMOTE_INSTALL_JSON = 'application/vnd.atl.plugins.remote.install+json';
export const INSTALL_COMPLETE_JSON = 'application/vnd.atl.plugins.install.complete+json';